import { formatShortDateWithWeekday } from "@clipboard-health/date-time";
import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type ClipboardScoreLog } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreHistory";
import { type ClipboardScorePolicy } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

import { ActivityItemForLog } from "../Activity/ItemForLog";

interface ClipboardScoreHistorySectionProps {
  date: string;
  logs: ClipboardScoreLog[];
  isDynamicPenaltiesEnabled: boolean;
  expandedRow: string | false;
  onClick: (id: string, isExpanded: boolean) => void;
  useExpectedArrivalTime: boolean;
  policy?: ClipboardScorePolicy;
  isEmergencyCreditsEnabled?: boolean;
}

export function ClipboardScoreHistorySection(props: ClipboardScoreHistorySectionProps) {
  const {
    date,
    logs,
    isDynamicPenaltiesEnabled,
    expandedRow,
    onClick,
    useExpectedArrivalTime,
    policy,
    isEmergencyCreditsEnabled,
  } = props;
  const title = formatShortDateWithWeekday(date);

  return (
    <Stack spacing={4}>
      <Text bold color={(theme) => theme.palette.text.disabled}>
        {title}
      </Text>
      {logs.map((log) => {
        const id = `history-${log.id}`;

        return (
          <ActivityItemForLog
            key={id}
            showDetails
            id={id}
            log={log}
            isDynamicPenaltiesEnabled={isDynamicPenaltiesEnabled}
            expanded={expandedRow === id}
            useExpectedArrivalTime={useExpectedArrivalTime}
            policy={policy}
            isEmergencyCreditsEnabled={isEmergencyCreditsEnabled}
            onClick={onClick}
          />
        );
      })}
    </Stack>
  );
}
